.container
    .row
        .col-xs-12
            div Launching Appcues Chrome Extension...